// extracted by mini-css-extract-plugin
export default {"app-layout":"c9Mvc","vIndented":"oBrX1"};